import React, { Component } from 'react';
import { getGameTime, convertDate } from './Utils.js';

class GameStatsGeneral extends Component {
    render() {
        let data = this.props.data;
        let winState = data["won"] ? "LOST" : "WON";
        let gameLength = getGameTime(data['length']);
        let gameLag = data["lag"];
        let score = data["score"];
        let advantage = null;

        if(data["has_percent_data"]) {
            advantage = data["advantage"]["right_team"];
        }

        let percents = data["has_percent_data"] ? `Advantage: ${advantage}%` : "Game Has No Percent Data";
        let lagInfo = data["has_lag_data"] ? <h3>Lag: {gameLag}</h3> : <h3>No Lag Data</h3>;
        return (
            <div className="general">
              <h3>{convertDate(data["start_date"])}</h3>
              <h3>{winState}</h3>
              <h3>Length: {gameLength}</h3>
              { lagInfo }
              <h3>Score: {Math.abs(score)} stock</h3>
              <h3>{percents}</h3>
            </div>
        );
    }
}

export default GameStatsGeneral;
